import * as service from './service'
export default {
  namespace: 'issProvinceCityArea',
  state: {
    cityData: {}
  },
  effects: {
    * getCity ({ payload }, { call, put }) {
      const res = yield call(service.getCity, payload)
      yield put({
        type: 'save',
        payload: {
          cityData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
